import Arrow from "../Arrow";

export default function NextArrow(props) {
  const { onClick, style } = props;
  return (
    <div
      onClick={onClick}
      className={`slick-next slick-arrow`}
      aria-hidden="true"
      style={{ ...style }}
    >
      <Arrow color={"#fff"} style={{ rotate: "90deg" }} />
    </div>
  );
}
